import React, { ReactElement } from 'react';
import { Text } from 'idsk-react-components';
import PravoEuListPage from '../../../model/PravoEuListPage';
import PravoEuListRow from './PravoEuListRow';
import './pravoEuListComponent.scss';

interface Props {
  pravoEuPage: PravoEuListPage;
  isSelectedFilter: boolean;
}

const PravoEuListComponent = ({ pravoEuPage, isSelectedFilter }: Props): ReactElement => {
  if (pravoEuPage.totalElements === 0 && isSelectedFilter) {
    return (
      <Text type="p" size="l" className="text-center">Nenašli sa žiadne predpisy zodpovedajúce zvolenému filtru.</Text>
    );
  }

  if (pravoEuPage.totalElements === 0) {
    return <Text type="p" size="l" className="text-center">Neexistujú žiadne predpisy.</Text>;
  }

  if (pravoEuPage.totalElements > 0 && pravoEuPage.predpisList.length === 0) {
    return (
      <Text type="p" size="l" className="text-center">
        Na aktuálnej stránke sa nenachádzajú žiadne predpisy.
      </Text>
    );
  }

  return (
    <>
      {pravoEuPage.predpisList.map((pravoEuItem) => (
        <PravoEuListRow pravoEuItem={pravoEuItem} key={pravoEuItem.uuid} />
      ))}
    </>
  );
};

export default PravoEuListComponent;
